import React from "react";
import { FilePlus as icon } from "react-feather";

import { INotificationPlugin } from "../INotificationPlugin";

interface Data {
  name: string;
  folder: string;
}

export default {
  title: "New document",
  icon,
  getDescription: data => <><strong>{data.name}</strong> was added in <strong>{data.folder}</strong></>,
} as INotificationPlugin<Data>;
